<script lang="ts" setup>
import { lastStep, step, slideJson } from "@/views/home/slidePPT/use/data";
import { storeToRefs } from "pinia";
import PPTStore from "@/stores/PPTStore";
import { _postSavePPT } from "@/api";
// 定义接口
// interface IPPTList {
//   id: number;
//   name: string;
//   url: string;
//   isEdit: boolean;
//   moreActive: boolean;
// }

// 定义 props
const props = withDefaults(
  defineProps<{
    PPTList: any[];
    type: string;
  }>(),
  {
    PPTList: () => [],
    type: "common",
  }
);
const router = useRouter();
const { PPTList, type } = toRefs(props);
const { curentPPT } = storeToRefs(PPTStore());

const linkEditPPT = async (item: any) => {
  curentPPT.value = item;
  fetch(item.ppt_json).then(async (res: any) => {
    const data = await res.json();
    slideJson.value = data;
    step.value = "slide-ppt";
    router.push("/slidePPT");
    nextTick(() => {
      lastStep.value = "next";
    });
  });
};
</script>

<template>
  <div class="production-container" full flex flex-wrap gap-20px>
    <div
      v-if="PPTList.length <= 0 && type == 'recycle'"
      full
      flex
      flex-col
      justify-center
      items-center
    >
      <el-image src="/images/recycle-empty.png" w-400px />
      <div>回收站中还没有作品</div>
    </div>
    <div
      class="production-item"
      v-for="(item, index) in PPTList"
      :key="item.id"
      bg-white
      shadow-lg
      rounded-10px
      flex
      flex-col
      justify-between
    >
      <div
        class="image-container"
        w-full
        cursor-pointer
        @click="linkEditPPT(item)"
        rounded-t-10px
        overflow-hidden
      >
        <el-image
          min-h-144px
          w-full
          :src="item.cover_url || '/images/ppt.png'"
          fit="contain"
        />
      </div>
      <div class="title-container">
        <div line-clamp-1 mr-8px>{{ item.name }}</div>
        <div
          relative
          @mouseenter="item.moreActive = true"
          @mouseleave="item.moreActive = false"
        >
          <div
            :style="{
              backgroundColor: item.moreActive ? '#f1f1f1' : '',
            }"
            w-20px
            h-20px
            flex
            justify-center
            items-center
            cursor-pointer
          >
            <span class="iconfont ppt-gengduo"></span>
          </div>
          <div v-show="item.moreActive" class="menu-container" absolute>
            <slot :item="item" :index="index" :key="item.id"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.production-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.production-item {
  flex: 1 1 calc(20% - 20px);
  max-width: calc(20% - 20px);
  box-sizing: border-box;
  .image-container {
    width: 100%;
  }
  .title-container {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px 0 20px;
  }
}
.menu-container {
  right: 0;
  padding: 10px 0px;
  width: 100%;
  min-width: 220px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  z-index: 99;
  overflow: hidden;
  .menu-item {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    &:last-child {
      border-bottom: 0px;
    }
  }
}

/* 媒体查询，调整每行显示的元素数量 */
@media (max-width: 1400px) {
  .production-item {
    flex: 1 1 calc(25% - 20px); /* 每行4个元素 */
    max-width: calc(25% - 20px);
  }
}

@media (max-width: 1100px) {
  .production-item {
    flex: 1 1 calc(33.33% - 20px); /* 每行3个元素 */
    max-width: calc(33.33% - 20px);
  }
}

@media (max-width: 800px) {
  .production-item {
    flex: 1 1 calc(50% - 20px); /* 每行2个元素 */
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 500px) {
  .production-item {
    flex: 1 1 calc(100% - 20px); /* 每行1个元素 */
    max-width: calc(100% - 20px);
  }
}

:deep(.el-menu--horizontal) {
  border: none;
  width: 30px;
}
:deep(.el-menu--horizontal .el-sub-menu.is-active .el-sub-menu__title) {
  border: none;
  color: #000;
  background-color: transparent;
}
</style>
